import isEqual from 'lodash.isequal';

export function areSameActiveElements(prevActiveElements: string[] = [], newActiveElements: string[] = []) {
  return !isEqual(prevActiveElements, newActiveElements);
}
